export const STYLING_TOOL_BAR_CONSTANTS = {
    FONT: 'font',
    FONT_WEIGHT: 'font-weight',
    FONT_SIZE: 'font-size',
    FONT_COLOR: 'color',
    FONT_STYLE: 'font-style',
};
